import { createSelector } from 'reselect';
import { getMachineOperationalStatus } from './getMachineOperationalStatus';
import { getWaitingForWorkEnabled } from './getWaitingForWorkEnabled';

export const getOperationalStatus = createSelector(
  [getMachineOperationalStatus, getWaitingForWorkEnabled],
  (machineOperationalStatus, waitingForWorkEnabled) => {
    if (!waitingForWorkEnabled) return null;
    return machineOperationalStatus?.status ?? null;
  }
);
